import { useQuery } from '@tanstack/react-query';
import { inspectionDB } from '../data/database.structure';
import { EquipmentTypeModel } from '../data/types';

const fetchItems = async (): Promise<EquipmentTypeModel[]> => {
  const equipmentTypes = await inspectionDB.equipmentTypes.toArray();
  return equipmentTypes;
};

export function useEquipmentTypes() {
  return useQuery<EquipmentTypeModel[]>({
    queryKey: ['equipmentTypes'],
    queryFn: fetchItems,
    staleTime: Infinity, // Never goes stale
    refetchOnWindowFocus: false, // Don't refetch on tab focus
    refetchOnReconnect: false, // Don't refetch on network reconnect
    networkMode: 'always',
  });
}
